
const config = require("config");

(function () {
  var serviceId = "mapService";
  angular
    .module("alk.maps")
    .factory(serviceId, ["$http", "$window", "$rootScope", "$q", "$compile", "$filter", "_", "alkGeocodeService", "STATES", "ALKMaps", "UserProvider", "alkModalService", "LocationItem", "eventTracker",
      function mapService($http, $window, $rootScope, $q, $compile, $filter, _, alkGeocodeService, STATES, ALKMaps, userProvider, alkModalService, LocationItem, eventTracker) {
        var maps = [];
        var isIE = false;
        var weatherLegend = document.getElementById("weatherLegend");
        var savedCenters = {};

        function saveCenter(centerInfo, id) {
          savedCenters[id] = centerInfo;
        }

        function getSavedCenter(id) {
          return savedCenters[id];
        }

        if ($window.navigator.userAgent.match(/Trident/)) {
          isIE = true;
        }

        var iconStyle = function (externalGraphic) {
          return {
            externalGraphic: ALKMaps._getScriptLocation() + externalGraphic,
            graphicHeight: 26,
            graphicWidth: 26,
            graphicXOffset: -12,
            graphicYOffset: -26
          };
        };

        var startIconStyle = iconStyle("img/flag_start.png");
        var waypointIconStyle = iconStyle("img/flag_stop.png");
        var endIconStyle = iconStyle("img/flag_end.png");

        var isDraggable = true;

        function initializeMap(mapInst, mapId, ignoreGeolocation = false) {

          //TODO: check for existence of mapId
          var mapObj = _.find(maps, {
            id: mapId
          });

          if (mapObj === undefined) {
            mapObj = {};
            mapObj.id = mapId;
            maps.push(mapObj);
          }

          mapObj.savedInfo = {
            mapCenter: null,
            mapZoom: null,
            mapStyle: "default",
            showTraffic: false
          };
          mapObj.routeElements = [];
          mapObj.map = mapInst;
          mapObj.markerLayer = new ALKMaps.Layer.VectorMarkers("Marker Layer", {
            displayInLayerSwitcher: false
          });
          mapObj.trafficLayer = new ALKMaps.Layer.Traffic("ALK LiveTraffic™", {
            displayInLayerSwitcher: false
          }, {
            visibility: false,
            opacity: 0.8
          });
          mapObj.weatherAlertsLayer = new ALKMaps.Layer.WeatherAlerts("ALK LiveWeatherAlert", {
            optionControlVisible: false,
            displayInLayerSwitcher: false,
            visibility: false,
            externalDivForLegend: weatherLegend,
            onErrorCallback: function (err) {}
          });
          mapObj.weatherCloudLayer = new ALKMaps.Layer.XYZ("ALK LiveWeatherCloud", config.urlWeatherSatellite + ALKMaps.Util.getApiKey(true), {
            displayInLayerSwitcher: false,
            visibility: false,
            opacity: 0.5,
            attribution: ALKMaps.Services.getAttribution({
              className: "ALKMaps.PCMWEBUI.WeatherRadar"
            })
          });

          if (userProvider.getUser().region === "NA") {
            mapObj.weatherRadarLayer = new ALKMaps.Layer.XYZ("ALK LiveWeatherRadar", config.urlWeatherRadar + ALKMaps.Util.getApiKey(true), {
              displayInLayerSwitcher: false,
              visibility: false,
              opacity: 0.5,
              attribution: ALKMaps.Services.getAttribution({
                className: "ALKMaps.PCMWEBUI.WeatherRadar"
              })
            });
          } else {
            mapObj.weatherRadarLayer = new ALKMaps.Layer.WeatherRadarEU("ALK LiveWeatherRadar", {}, {
              optionControlVisible: false,
              displayInLayerSwitcher: false,
              visibility: false,
              onErrorCallback: function (err) {}
            });
          }

          mapObj.roadSurfaceLayer = new ALKMaps.Layer.RoadSurface("ALK RoadSurface", {
            provider: "RC1"
          }, {
            displayInLayerSwitcher: false,
            visibility: false,
            opacity: 0.5
          });

          mapObj.map.addLayers([mapObj.markerLayer, mapObj.trafficLayer, mapObj.weatherAlertsLayer, mapObj.weatherCloudLayer,
            mapObj.weatherRadarLayer, mapObj.roadSurfaceLayer]);

          mapObj.navHistoryControl = new ALKMaps.Control.NavigationHistory();
          mapObj.zoomBoxControl = new ALKMaps.Control.ZoomBox({
            autoActivate: false
          });
          mapObj.map.addControls([mapObj.navHistoryControl, mapObj.zoomBoxControl]);

          mapObj.mapStyle = mapObj.savedInfo.mapStyle;

          if ($window.navigator.geolocation && ignoreGeolocation !== true) {
            if (mapObj.savedInfo.mapCenter === null) {
              $window.navigator.geolocation.getCurrentPosition(
                (pos) => {
                  plotCurrentPosition(pos, mapObj.id);
                });
            }
          }

          setMapStyle(mapObj.mapStyle, mapObj.id);
          mapObj.trafficLayer.setVisibility(mapObj.savedInfo.showTraffic);
          mapObj.weatherAlertsLayer.legendControl.header.innerHTML = "<h3 class='title'>Weather Alerts</h3>";
        }

        function releaseMap(mapId, broadcast = false) {
          var mapObj = getMapFromId(mapId);

          if (mapObj.map !== null) {
            mapObj.savedInfo.mapCenter = mapObj.map.getCenter();
            mapObj.savedInfo.mapZoom = mapObj.map.getZoom();
            mapObj.savedInfo.mapStyle = mapObj.mapStyle;
          }

          if (broadcast) {
            $rootScope.$broadcast("releaseMap", {
              center: mapObj.map.getCenter(),
              zoom: mapObj.map.getZoom(),
              style: mapObj.mapStyle
            });
          }

          mapObj.map = null;
          mapObj.markerLayer = null;
          mapObj.routeElements = [];
          mapObj.trafficLayer = null;
          mapObj.searchMarker = null;
          mapObj.markerPopup = null;
          mapObj.currentLoc = null;
          mapObj.navHistoryControl = null;
          mapObj.zoomBoxControl = null;
          mapObj.mapStyle = "default";
          mapObj.avoidFavorsLayer = null;
        }

        function restoreCenterZoom(mapId) {
          var mapObj = getMapFromId(mapId);

          if ((mapObj.savedInfo.mapCenter !== null) && (mapObj.savedInfo.mapZoom !== null)) {
            mapObj.map.setCenter(mapObj.savedInfo.mapCenter, mapObj.savedInfo.mapZoom);
          }
        }

        function clearSavedCenterZoom(mapId) {
          var mapObj = getMapFromId(mapId);

          if (mapObj) {
            mapObj.savedInfo = {
              mapCenter: null,
              mapZoom: null,
              mapStyle: "default",
              showTraffic: false
            };
          }
        }

        function clearRouteMarkers(routeId, mapId) {
          var mapObj = getMapFromId(mapId);
          var re = getRouteElements(routeId);
          for (var i = 0; i < re.routeMarkers.length; i++) {
            mapObj.markerLayer.removeMarker(re.routeMarkers[i]);
          }

          re.routeMarkers = [];
        }

        function updateRouteMarkers(routeId, routeColor, stops, options, mapId) {
          var mapObj = getMapFromId(mapId);
          clearRouteMarkers(routeId, mapId);

          var re = getRouteElements(routeId);

          for (var i = 0; i < stops.length; i++) {
            var stopData = stops[i].Coords;
            var ll = new ALKMaps.LonLat(stopData.Lon, stopData.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

            //var mStyle = waypointIconStyle;
            var mStyle = {
              externalGraphic: "",
              fontColor: $filter("colorFilter")(routeColor, "lighten", 0.25),
              fontSize: "11",
              fontWeight: "700",
              strokeColor: $filter("colorFilter")(routeColor, "lighten", 0.2),
              pointRadius: 9,
              strokeWidth: 3,
              fillColor: "#FFFFFF",
              label: "",
              labelYOffset: (isIE) ? -4 : 0
            }
            if (i === stops.length - 1 && !options.hubRouting) {
              //mStyle = endIconStyle;
              mStyle = {
                externalGraphic: "",
                fontColor: "#e25656",
                fontSize: "11",
                fontWeight: "700",
                strokeColor: "#be2525",
                pointRadius: 6.5,
                strokeWidth: 5.5,
                fillColor: "#FFFFFF",
                label: "",
                labelYOffset: (isIE) ? -4 : 0
              }
            }
            if (i === 0) {
              //mStyle = startIconStyle;
              mStyle = {
                externalGraphic: "",
                fontColor: "#259800",
                fontSize: "11",
                fontWeight: "700",
                strokeColor: "#279E00",
                pointRadius: 6.5,
                strokeWidth: 5.5,
                fillColor: "#FFFFFF",
                label: "",
                labelYOffset: (isIE) ? -4 : 0
              }
            }

            re.routeMarkers.push(mapObj.markerLayer.createMarker(ll, {
              markerType: "custom"
            }, mStyle));
          }
        }

        function getMap(mapId) {
          var mapObj = getMapFromId(mapId);
          return mapObj.map;
        }

        function getLayer(mapId, layer) {
          var mapObj = getMapFromId(mapId);
          return mapObj[layer];
        }

        function zoomIn(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.map.zoomIn();
        }

        function zoomOut(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.map.zoomOut();
        }

        function boxZoom(active, mapId) {
          var mapObj = getMapFromId(mapId);
          if (active) {
            mapObj.zoomBoxControl.activate();
          } else {
            mapObj.zoomBoxControl.deactivate();
          }
        }

        function currentZoom(mapId) {
          var mapObj = getMapFromId(mapId);
          return mapObj.map.getZoom();
        }

        function goBack(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.navHistoryControl.previousTrigger();
        }

        function goForward(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.navHistoryControl.nextTrigger();
        }

        function historyStack(mapId) {
          var mapObj = getMapFromId(mapId);
          return {
            backCount: mapObj.navHistoryControl.previousStack.length,
            forwardCount: mapObj.navHistoryControl.nextStack.length
          };
        }

        //#region Routing and Reporting Methods
        function cleanupStops (stops, mapId) {
          var mapObj = getMapFromId(mapId);
          var tempStops = [];
          for (var i = 0; i < stops.length; i++) {
            var stopData = stops[i].Coords;
            var ll = new ALKMaps.LonLat(stopData.Lon, stopData.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());
            stops[i].smLonLat = ll;
            tempStops.push(ll);
          }
          return tempStops;
        }

        function getStopCosts (stops) {
          var stopCosts = "";
          for (var i = 0; i < stops.length; i++) {
            if (i > 0) {
              stopCosts += "|";
            }
            var durationInHours = stops[i].getDurationInHours();
            if (!durationInHours) {durationInHours = 0;}
            stopCosts += `0.0,${  durationInHours  },true,true,false`;
          }
          return stopCosts;
        }

        function _parseEstimatedTimeOpts (data) {
          if (data == null || data === "" || data.type === "None") {
            return null;
          }

          var eto = {};
          var DayOfWeekEnum = {
            Sunday: 0,
            Monday: 1,
            Tuesday: 2,
            Wednesday: 3,
            Thursday: 4,
            Friday: 5,
            Saturday: 6
          };

          // ETAETD param
          if (data.type === "now" || data.type === "Depart") {
            eto.ETAETD = 1; // Depart
          } else {
            eto.ETAETD = 0; // Arrival
          }

          // DateOption and DateAndTime param
          if (data.type === "now") {
            eto.DateOption = 0; // Current
            eto.DateAndTime = null;
          } else if (data.datetype === "date") {
            eto.DateOption = 1; // Specific
            eto.DateAndTime = {
              CalendarDate: data.date,
              DayOfWeek: DayOfWeekEnum[data.weekday],
              TimeOfDay: data.time,
              TimeZone: 0
            };
          } else if (data.datetype === "weekday") {
            eto.DateOption = 2; // DayOfWeek
            eto.DateAndTime = {
              CalendarDate: null,
              DayOfWeek: DayOfWeekEnum[data.weekday],
              TimeOfDay: data.time,
              TimeZone: 0
            };
          }

          return eto;
        }

        function getErrorMsg (resp) {
          var error = "";
          try {
            var responseText = JSON.parse(resp.responseText);
            error = responseText[0].Description;
          } catch (e) {
            if (resp.status && resp.statusText) {
              error = `${resp.status} ${resp.statusText}`;
            } else {
              error = "Unknown error";
            }
          }
          return error;
        }

        /*
          For premium customers, if they enable ALK/Custom places layers, there will have a conflict with routing layer.
          Thus, we need to deactivate and then reactivate feature event control for this routing layer and ALK/Custom places layers
          every time addRoute() is called. Otherwise, either you can not drag route, or you can not hover over or click POIs
        */
        function resetFeatureEventControl() {

          var layers = getLayersFromMap((s) => {
            return s.name.indexOf("PlaceSetLayer") > -1
          });
          var routingLayers = getLayersFromMap((s) => {
            return s.name.indexOf("Routing Layer") > -1
          });
          if (layers && layers.length > 0) {
            removeFeatureEventControl();
            _.forEach(routingLayers, (r) => {
              layers.push(r);
            });
            addFeatureEventControl(layers);
          }
        }

        function addRoute(routeId, routeColor, stops, options, frameRoute, callback, errorCallback, mapId) {
          var re = getRouteElements(routeId, mapId);

          resetFeatureEventControl();
          //clean up stops
          var tempStops = cleanupStops(stops, mapId);
          var stopCosts = getStopCosts(stops);

          updateRouteMarkers(routeId, routeColor, stops, options);
          removeRoute(routeId, mapId);

          var findStop = function (x, y) {
            var findme = null;
            for (var j = 0; j < tempStops.length; j++) {
              var tempStop = tempStops[j];
              if ((tempStop.lat === y && tempStop.lon === x) ||
                (distanceTo(tempStop.lon, tempStop.lat, x, y) <= 0.25)) { // Todo: Report service does not return the same lat/lons as inputs. If a returned point is within 0.25 meter, we consider it match.
                findme = stops[j];
                //Set lat/lon to unused values to keep identical (favorite) stops from being matched again [PCMW-137].
                tempStops[j].lat = NaN;
                tempStops[j].lon = NaN;
                break;
              }
            }

            return findme;
          };

          var reOrderStops = function (resp) {
            if (options.routeOptimization == null || (options.routeOptimization != null && options.routeOptimization === 0)) {
              clearRouteMarkers(routeId);
              resp.stops = stops;
              callback(resp);
            } else {
              var stopList = resp.stops;
              var optimizedStops = [];
              for (var k = 0; k < stopList.length; k++) {
                var astop = stopList[k];
                var waypoint = findStop(astop.x, astop.y);
                optimizedStops.push(waypoint);
              }

              resp.stops = optimizedStops;
              clearRouteMarkers(routeId);
              callback(resp);
            }

          };

          var routingError = function (resp) {
            var error = getErrorMsg(resp);
            alkModalService.show({
              size: "sm"
            }, {
              headerText: "Routing Error",
              bodyText: error,
              okOnly: true
            }).then(() => {
              $rootScope.$broadcast("FocusSearchField");
            });
            errorCallback(error);
          };

            re.routingLayer.addRoute({
            stops: tempStops,
            stopCosts: stopCosts, // second field is the stop duration, other fields keep it 0.0 or true.
            functionOptions: {
              routeId: routeId,
              callback: reOrderStops,
              failure: routingError,
              frameRoute: (frameRoute === undefined) ? true : frameRoute,
              style: {
                strokeWidth: 9,
                strokeOpacity: 0.7,
                strokeColor: routeColor
              }
            },
            routeOptions: options
          });
        }

        function addReport(routeId, stops, options, uiArrDepSelection, rptType, callback, errorCallback) {
          var ReportRoutes = {};
          // routeId param
          ReportRoutes.RouteId = routeId;
          // stops param
          if (!options.dataset) {
            options.dataset = userProvider.getUser().dataset;
          }
          ReportRoutes.Stops = populateStops(stops, options);
          //check if thwere are stops
          if (!ReportRoutes.Stops || ReportRoutes.Stops.length < 2) {
            return;
          }
          // route option param
          ReportRoutes.Options = populateRouteOptions(options);
          // report option param
          ReportRoutes.ReportingOptions = populateReportOptions(options, uiArrDepSelection);
          var requestDataVersion = "";
          // for NA region, if it's current dataVersion, use PCM_NA; otherwise, use specific version like PCM30, PCM29
          if (userProvider.getUser().dataset === "PCM_NA") {
            requestDataVersion = (options.dataVersion === "current") ? "PCM_NA" : options.dataVersion;
          } else {
            // for OC, EU region, always use PCM_XX for dataVersion for report request
            requestDataVersion = userProvider.getUser().dataset;
          }
          // report type param
          ReportRoutes.ReportTypes = populateReportType(rptType);
          // fuel option param
          ReportRoutes.FuelOptions = null;
          var data = {
            request: {ReportRoutes : [ ReportRoutes ]},
            dataVersion: requestDataVersion,
            success: callback,
            failure: errorCallback
          };

          var request = {
            method: "POST",
            url: `${config.pcmwsUrl}route/routeReports?dataVersion=${data.dataVersion}`,
            headers: {
              Authorization: config.reportApiKey[userProvider.getUser().region || "NA"] + "|" + userProvider.getUser().authToken + "|" + new Date().toISOString()
            },
            data:{
              ReportRoutes : [ ReportRoutes ]
            }
          };
          $http(request).then(results => {
            callback(results.data);
          }, error => {
            errorCallback(error);
          });
        }
        // Helper Function for addReport
        function populateStops(stopsIn, options) {
          const isEU = options.dataVersion == "PCM_EU";
           const stopsOut = [];
          
            
           if(checkHistoricalVersion(options.dataVersion)){
          _.forEach(stopsIn, stop => {
          
            var temp = {};
            var useLatLon = stop.origLatlon ? true : false; // if user input is latlon
            var hasSPLC = !!(stop && stop.Address && stop.Address.SPLC);
            const hasLatLon = !!((stop && stop.Coords && stop.Coords.Lat && stop.Coords.Lon));            
            const hasAddress = stop.Address.StreetAddress !== "" || stop.Address.City !== "" || stop.Address.Country !== "" ||
              stop.Address.County !== "" && stop.Address.County !== null || stop.Address.State !== "" || stop.Address.Zip !== "";
              temp.Coords = angular.copy(stop.Coords);
              temp.Address = angular.copy(stop.Address);
            if (!isEU) { // dataVersion is not EU
              temp.Coords = angular.copy(stop.Coords); // always send coords
              if (options.dataset !== "PCM_EU" ) {
                // SWPWEB-1238, SWPWEB-1334
                if (useLatLon) {
                  temp.Address = null; // use only coords even if stop has addr
                } else if(hasSPLC) {
                  temp.Address = null;
                  temp.Coords = null;
                  temp. Address = { SPLC: stop.Address.SPLC}
                } else if (hasLatLon) {
                 temp.Address = null;
                } else { // !useLatLon && !hasAddress
                  temp.Address = angular.copy(stop.Address);
                  temp.Coords = null;
                  temp.Address.CountryPostalFilter = 2; // To handle both US and Mexico zipcode.
                }
              }

              // EU Region some state return "" while the value is actually in Country.
              // dataset can be EU even if dataversion is not.
              if (options.dataset === "PCM_EU" && temp.Address.State === "") {
                temp.Address.State = temp.Address.Country;
              }
            } else { // isEU
               temp.Coords = angular.copy(stop.Coords);
               temp.Address = null;
            }
            temp.PlaceName = null;
            var durationInHours = stop.getDurationInHours();
            if (!durationInHours) { durationInHours = 0; }
            temp.Costs = {
              CostOfStop: 0.0,
              HoursPerStop: durationInHours,
              Loaded: true,
              OnDuty: true,
              UseOrigin: false
            }

            stopsOut.push(temp);
          
         
          });
          return stopsOut;
        }
      else {
        _.forEach(stopsIn, stop => {
          
          var temp = {};
         
          var hasSPLC = !!(stop && stop.Address && stop.Address.SPLC);
         
          if (!isEU) { // dataVersion is not EU
            temp.Coords = angular.copy(stop.Coords); // always send coords
            temp.Address = angular.copy(stop.Address);
            if (options.dataset !== "PCM_EU" ) {
             
              if(hasSPLC) {
                temp.Address = null;
                temp.Coords = null;
                temp. Address = { SPLC: stop.Address.SPLC}
              } else{
                temp.Address = angular.copy(stop.Address);
                temp.Address.CountryPostalFilter = 2; // To handle both US and Mexico zipcode.
              }
            }

            // EU Region some state return "" while the value is actually in Country.
            // dataset can be EU even if dataversion is not.
            if (options.dataset === "PCM_EU" && temp.Address.State === "") {
              temp.Address.State = temp.Address.Country;
            }
          } else { // isEU
             temp.Coords = angular.copy(stop.Coords);
             temp.Address = null;
            
          }
          temp.PlaceName = null;
          var durationInHours = stop.getDurationInHours();
          if (!durationInHours) { durationInHours = 0; }
          temp.Costs = {
            CostOfStop: 0.0,
            HoursPerStop: durationInHours,
            Loaded: true,
            OnDuty: true,
            UseOrigin: false
          }

          stopsOut.push(temp);
        
       
        });
        return stopsOut;
        }
        }
        // Helper Function for addReport
        function populateRouteOptions(options) {
          var tempRouteOptions = {
            BordersOpen: options.bordersOpen,
            ClassOverrides: options.classOverrides,
            DistanceUnits: options.distanceUnits,
            ElevLimit: options.elevLimit,
            FerryDiscourage: options.ferryDiscourage,
            UseSites: options.useSites,
            GovernorSpeedLimit: options.governorSpeedLimit,
            HazMatType: options.hazMatType,
            HighwayOnly: options.highwayOnly,
            HubRouting: options.hubRouting,
            OverrideRestrict: options.overrideRestrict,
            RouteOptimization: options.routeOptimization,
            RoutingType: options.routingType,
            SideOfStreetAdherence: options.sideOfStreetAdherence,
            TollDiscourage: options.tollDiscourage,
            VehicleType: options.vehicleType
          };
          // convert comma-separated string of ints into array of ints
          if (options.afSetIDs) {
            if (typeof (options.afSetIDs) === "object")
            {
              options.afSetIDs = options.afSetIDs.toString();
            }
            tempRouteOptions.AFSetIDs = options.afSetIDs.split(",").map(s => parseInt(s));
          }

          // SWPWEB-961 - If classOverrides is 3(nationalNetwork + fiftyThreeFoot) while report version is PCM18 - 21, set it to 2.
          if (tempRouteOptions.ClassOverrides === 3 &&
            ["PCM18", "PCM19", "PCM20", "PCM21"].indexOf(options.dataVersion) > -1) {
            tempRouteOptions.ClassOverrides = 2;
          }

          // if vehicle type is not Auto, provide truck config
          if (options.vehicleType !== 2) {
            tempRouteOptions.TruckCfg = {
              Axles: options.trkAxles,
              Height: options.trkHeight,
              LCV: options.trkLCV,
              Length: options.trkLength,
              Weight: options.trkWeight,
              Width: options.trkWidth,
              Units: options.trkUnits
            };
          }

          // additional EU Trailer config if any
          if ((options.dataVersion === "PCM_EU" || options.dataset === "PCM_EU") && options.EUOptions && options.EUOptions.hasTrailer) {
            //to-do, pass EU trailer config.
            tempRouteOptions.TrailerCfg = {
              TypeOfTrailer: options.EUOptions.trlType,
              Count: options.EUOptions.trlCount,
              MaxHeight: options.EUOptions.trlMaxHt,
              MaxWeight: options.EUOptions.trlMaxWt,
              MaxAxles: options.EUOptions.trlMaxAxles,
              Engine: {
                Hybrid: options.EUOptions.isHybrid,
                EmissionType: options.EUOptions.emiType,
                MinPollutionVeh: options.EUOptions.minPoll
              }
            };
          }
          return tempRouteOptions;
        }
        // Helper Function for addReport
        function populateReportOptions(options, uiArrDepSelection) {
          var tempReportOptions = {
            UseTraffic: options.useTraffic,
            ExchangeRate: options.ExchangeRate,
            FuelUnits: options.fuelUnits,
            TollCurrency: options.tollCurrency,
            TollDiscount: options.tollPlan,
            UseTollData: options.inclTollData,
            reportFmt: "JSON" // for ALKMaps use only
          };

          // only provide route costs when it's current or PCM_EU dataVersion
          // Note we do not use fuelEconEmpty, costMaintEmpty and costTimeEmpty. Pass 0.0 in request.
          if (options.dataVersion === "current" || options.dataVersion === "PCM_EU") {
            tempReportOptions.RouteCosts = {
              PricePerFuelUnit: options.costPerFuelUnit,
              GreenHouseGas: options.costGHG,
              FuelEconomyLoaded: options.fuelEconLoad,
              FuelEconomyEmpty: 0.0, //options.fuelEconEmpty,
              OtherCostPerDistUnitLoaded: options.costMaintLoad,
              OtherCostPerDistanceUnitEmpty: 0.0, //options.costMaintEmpty,
              CostTimeLoaded: options.costTimeLoad,
              CostTimeEmpty: 0.0 //options.costTimeEmpty
            };
          }

          // EU Emission param
          if (options.dataVersion === "PCM_EU" || options.dataset === "PCM_EU") {
            tempReportOptions.FuelConsumption = options.EUOptions.fuelConsumption;
            tempReportOptions.Refrigerated = options.EUOptions.refrigerated;
            tempReportOptions.FuelType = options.EUOptions.fuelType;
          }

          // add estimatedTimeOpts if there is any
          tempReportOptions.EstimatedTimeOptions = _parseEstimatedTimeOpts(uiArrDepSelection);
          return tempReportOptions;
        }
        // Helper Function for addReport
        function populateReportType(rptType) {
          var tempRptTypeOptions = [];
          if (rptType != null) {
            var rptArray = rptType.split(",");
            _.forEach(rptArray, rpt => {
              tempRptTypeOptions.push({
                "__type": `${rpt}ReportType:http://pcmiler.alk.com/APIs/v1.0`
              });
            });
          }
          return tempRptTypeOptions;
        }

        function addRoutePromise(routeId, routeColor, stops, options, frameRoute, mapId) {
          var deferred = $q.defer();

          addRoute(routeId, routeColor, stops, options, frameRoute, (response) => {
            deferred.resolve(response);
          }, (response) => {
            deferred.reject(response);
          }, mapId);

          return deferred.promise;
        }

        function addReportPromise(routeId, stops, options, uiArrDepSelection, rptType) {
          var deferred = $q.defer();

          addReport(routeId, stops, options, uiArrDepSelection, rptType, (response) => {
            deferred.resolve(response);
          }, (response) => {
            deferred.reject(getErrorMsg(response));
          });

          return deferred.promise;
        }

        function removePopup(mapId) {
          var mapObj = getMapFromId(mapId);
          //if (mapObj.searchMarker === null) {
          if (mapObj.markerPopup) {
            mapObj.map.removePopup(mapObj.markerPopup);
          }
          //}
        }

        function deleteRoute(routeId, mapId) {
          var mapObj = getMapFromId(mapId);
          var re = _.find(mapObj.routeElements, {
            id: routeId
          });

          if (re !== undefined) {
            re.routingLayer.setDraggable(false);
            removePopup(mapId);
            //re.routingLayer.destroy();
            // https://gis.stackexchange.com/questions/40552/openlayers-error-after-removing-selectfeature-control
            mapObj.map.events.unregister("moveend", re.routingLayer, re.routingLayer._onLayerMove);
            re.routingLayer.removeRoute(routeId);
            mapObj.map.removeLayer(re.routingLayer);
            _.remove(mapObj.routeElements, {
              id: routeId
            });
            resetFeatureEventControl();
            if (re.routeMarkers !== null) {
              for (var mkrIndex = 0; mkrIndex < re.routeMarkers.length; mkrIndex++) {
                mapObj.markerLayer.removeMarker(re.routeMarkers[mkrIndex]);
              }
            }
          }
        }

        function deleteAllRoutes(mapId) {
          var mapObj = getMapFromId(mapId);
          for (var k = mapObj.routeElements.length - 1; k >= 0; k--) {
            var route = mapObj.routeElements[k];
            deleteRoute(route.id, mapId);
          }
        }

        function removeRoute(routeId, mapId) {
          var re = getRouteElements(routeId, mapId);
          removePopup(mapId);
          re.routingLayer.removeRoute(routeId);
          resetFeatureEventControl();
        }

        function showRoute(routeId, mapId) {
          var re = getRouteElements(routeId, mapId);
          //showPopup(re, true);
          removePopup(mapId);
          re.routingLayer.setVisibility(true);
        }

        function hideRoute(routeId, mapId) {
          var re = getRouteElements(routeId, mapId);
          //showPopup(re, false);
          removePopup(mapId);
          re.routingLayer.setVisibility(false);
        }

        function frameRoute(routeId, mapId) {
          var re = getRouteElements(routeId, mapId);
          var mapObj = getMapFromId(mapId);
          mapObj.map.zoomToExtent(re.routingLayer.getDataExtent());
        }

        function activateRoute(routeId, mapId) {
          var mapObj = getMapFromId(mapId);
          removePopup(mapId);
          _.forEach(mapObj.routeElements, (re) => {
            if (re.id === routeId) {
              re.routingLayer.setOpacity(1);
              re.routingLayer.setDraggable(isDraggable);
              //showPopup(re, true);
            } else {
              re.routingLayer.setOpacity(0.6);
              re.routingLayer.setDraggable(false);
              //showPopup(re, false);
            }
          });
        }

        function setRouteHandle(routeId, mapId, stop, handleOptions) {
          var re = getRouteElements(routeId, mapId);
          re.routingLayer.setRouteHandle(routeId, stop, handleOptions);
        }

        function getRouteElements(routeId, mapId) {
          var mapObj = getMapFromId(mapId);
          //get/check for elements
          var re = _.find(mapObj.routeElements, {
            id: routeId
          });
          //create if needed
          if (re === undefined) {
            //create layer
            re = {};
            re.id = routeId;

            re.routingLayer = new ALKMaps.Layer.Routing(`Routing Layer ${ routeId }`, {
              isDraggable: isDraggable,
              originURL: "",
              waypointURL: "",
              destinationURL: ""
            });
            mapObj.map.addLayers([ re.routingLayer ]);
            mapObj.map.raiseLayer(re.routingLayer, -1);

            re.routeMarkers = [];
            re.stops = [];


            re.routingLayer.onRouteModified = function (response) {
              $rootScope.$broadcast("RouteModified", {
                response: response
              });
            };

            re.routingLayer.onErrorRouteModification = function (response) {
              $rootScope.$broadcast("RouteModifiedError", {
                response: response
              });
              re.routingLayer.dragControl.cancel();
            };

            re.routingLayer.dragControl.onStart = function (feature, pixel) { // jshint ignore:line
              this.dragStart = true;
              $rootScope.$broadcast("DragStart", {
                feature: feature
              });
            };

            re.routingLayer.dragControl.onDrag = function (feature, pixel) { // jshint ignore:line
              this.dragStart = true;
              removePopup(mapId);
            };

            re.routingLayer.dragControl.onComplete = function (feature, pixel) {
              $rootScope.$broadcast("DragEnd", {
                feature: feature
              });
              this.dragComplete(feature, pixel);
            };

            mapObj.routeElements.push(re);

          }

          return re;
        }

        //#endregion

        //#region Markers

        function showPin(resp, pan, controllerScope, mapId, onlyPin) {
          // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
          if(resp && resp.Coords && resp.Coords.Lat && !resp.Coords.Lat.includes(".")) {
            var hasNegative = resp.Coords.Lat.includes("-");
            var indexPosition = hasNegative ? resp.Coords.Lat.length > 9 ? 4 : 3 
                                            : resp.Coords.Lat.length > 8 ? 3 : 2;
            resp.Coords.Lat =   resp.Coords.Lat.substring(0, indexPosition)
            + "." + resp.Coords.Lat.substring(indexPosition);
          }
          if(resp && resp.Coords && resp.Coords.Lon && !resp.Coords.Lon.includes(".")) {
            var hasNegative = resp.Coords.Lon.includes("-");
            var indexPosition = hasNegative ? resp.Coords.Lon.length > 9 ? 4 : 3 
                                            : resp.Coords.Lon.length > 8 ? 3 : 2;
            resp.Coords.Lon = resp.Coords.Lon.substring(0, indexPosition)
            + "." + resp.Coords.Lon.substring(indexPosition);
          }
          // Ends Temporary fix
          var mapObj = getMapFromId(mapId);
          var tempStopListObj = {}
          tempStopListObj.lat = resp.Coords.Lat;
          tempStopListObj.lon = resp.Coords.Lon;

          clearSearchMarker(mapId);
          clearPlaceSearchMarker(mapId);

          var cleanLL = new ALKMaps.LonLat(resp.Coords.Lon, resp.Coords.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

          mapObj.searchMarker = mapObj.markerLayer.createMarker(
            cleanLL, {}, {
              externalGraphic: "/img/marker.png",
              graphicHeight: 33,
              graphicWidth: 28,
              graphicXOffset: -14,
              graphicYOffset: -28
            }
          );

          if (mapObj.markerPopup) {
            mapObj.map.removePopup(mapObj.markerPopup);
          }

          if (!onlyPin) {
            var addr;
            if (resp.CityStateZip) {
              addr = resp.CityStateZip;
            } else { //for alk sites @bpan @vani
              addr = `${resp.Address.City  },${  resp.Address.State  }${resp.Address.Zip}`;
            }

            if (resp.Address.StreetAddress !== "") {
              addr = `<b>${  resp.Address.StreetAddress  }</b><br>${  addr}`;
            }

            mapObj.markerPopup = new ALKMaps.Popup.SimplePopup(
              "GeocodingPopup",
              cleanLL,
              null, //autosize
              `<div class="popup-text">${
                addr
              }<div class="popup-actions">` +
              "    <button id=\"save-fav-btn\" class=\"btn btn-default btn-xs\" ng-disabled=\"!routeVm.canSavePopupFavorite()\" ng-click=\"routeVm.savePopupFavorite();\" title=\"{{(!userInfo.isPremium())?'Premium Only':''}}\" alk-analytics=\"['Map','Popup','Add Favorite']\">" +
              "        <i class=\"ico ico-star\"></i> Save" +
              "    </button>" +
              "    <button id=\"get-directions-btn\" class=\"btn btn-default btn-xs\" ng-click=\"routeVm.addSelectedLocationToRoute()\" alk-analytics=\"['Map','Popup','Add Stop to Route']\">" +
              "        <i class=\"ico ico-circle-plus\"></i> Add Stop" +
              "    </button>" +
              "</div>" +
              "</div>",
              new ALKMaps.Pixel(0, 4), //offset
              true,
              (() => {
                clearSearchMarker();
              }));

            mapObj.map.addPopup(mapObj.markerPopup);
          }

          if (pan) {
            safePanTo(cleanLL, 16, mapId);
          }

          //hacktastic fix to get Angular to recognize the popup added by ALKMaps
          var e = angular.element("#GeocodingPopup");
          $compile(e)(controllerScope);
        }

        function showPlacePin(location, controllerScope, mapId) {
          var mapObj = getMapFromId(mapId);

          var tempStopListObj = {}
          tempStopListObj.lat = location.Coords.Lat;
          tempStopListObj.lon = location.Coords.Lon;

          clearSearchMarker(mapId);
          clearPlaceSearchMarker(mapId);

          var cleanLL = new ALKMaps.LonLat(location.Coords.Lon, location.Coords.Lat)
            .transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

          var addr = "";
          if (location.Name !== null && location.Name !== undefined && location.Name !== "") {
            addr += `<b>${location.Name}</b>`;
          }
          if (location.Address.StreetAddress !== null && location.Address.StreetAddress !== undefined &&
            location.Address.StreetAddress !== "") {
            addr += `<br>${location.Address.StreetAddress}`;
          }
          if (location.CityStateZip !== null && location.CityStateZip !== undefined && location.CityStateZip !== "") {
            addr += `<br>${location.CityStateZip}`;
          }

          mapObj.placeMarkerPopup = new ALKMaps.Popup.SimplePopup(
            "GeocodingPopup",
            cleanLL,
            null, //autosize
            `<div class="popup-text">${
              addr
            }<div class="popup-actions">` +
            "    <button id=\"save-fav-btn\" class=\"btn btn-default btn-xs\" disabled ng-click=\"routeVm.savePopupFavorite();\" title=\"{{(!userInfo.isPremium())?'Premium Only':''}}\" alk-analytics=\"['Map','Popup','Add Favorite']\">" +
            "        <i class=\"ico ico-star\"></i> Save" +
            "    </button>" +
            "    <button id=\"get-directions-btn\" class=\"btn btn-default btn-xs\" ng-click=\"routeVm.addSelectedLocationToRoute()\" alk-analytics=\"['Map','Popup','Add Stop to Route']\">" +
            "        <i class=\"ico ico-circle-plus\"></i> Add Stop" +
            "    </button>" +
            "</div>" +
            "</div>",
            new ALKMaps.Pixel(0, 28), //offset
            true,
            (() => {
              clearPlaceSearchMarker();
            }));

          mapObj.map.addPopup(mapObj.placeMarkerPopup);

          //hacktastic fix to get Angular to recognize the popup added by ALKMaps
          var e = angular.element("#GeocodingPopup");
          $compile(e)(controllerScope);
        }

        function showPlaceHoverPopup(location, controllerScope, mapId) {
          var mapObj = getMapFromId(mapId);

          if (location.CityStateZip === null || location.CityStateZip === undefined) {
            if (location.PlaceName !== null && location.PlaceName !== undefined) {
              location = new LocationItem(location, location.PlaceName)
            } else {
              location = new LocationItem(location);
            }
          }

          var tempStopListObj = {}
          tempStopListObj.lat = location.Coords.Lat;
          tempStopListObj.lon = location.Coords.Lon;

          clearSearchMarker(mapId);

          var cleanLL = new ALKMaps.LonLat(location.Coords.Lon, location.Coords.Lat)
            .transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

          let addr = "";
          if (location.Name !== null && location.Name !== undefined && location.Name !== "") {
            addr += `<b>${location.Name}</b>`;
          }
          if (location.Address.StreetAddress !== null && location.Address.StreetAddress !== undefined &&
            location.Address.StreetAddress !== "") {
            addr += `<br>${location.Address.StreetAddress}`;
          }
          if (location.CityStateZip !== null && location.CityStateZip !== undefined && location.CityStateZip !== "") {
            addr += `<br>${location.CityStateZip}`;
          }

          if (mapObj.markerPopup) {
            mapObj.map.removePopup(mapObj.markerPopup);
          }

          mapObj.markerPopup = new ALKMaps.Popup.SimplePopup(
            "GeocodingPopup",
            cleanLL,
            null, //autosize
            `<div class="geocode-popup-text">${addr}</div>`,
            new ALKMaps.Pixel(0, 10), //offset
            true,
            clearSearchMarker);

          mapObj.map.addPopup(mapObj.markerPopup);

          //hacktastic fix to get Angular to recognize the popup added by ALKMaps
          var e = angular.element("#GeocodingPopup");
          $compile(e)(controllerScope);
        }

        function clearSearchMarker(mapId) {
          var mapObj = getMapFromId(mapId);
          var retVal = false;

          if (mapObj.searchMarker) {
            retVal = true;
            mapObj.markerLayer.removeMarker(mapObj.searchMarker);
            mapObj.searchMarker = null;
          }

          if (mapObj.markerPopup) {
            mapObj.map.removePopup(mapObj.markerPopup);
          }

          return retVal;
        }

        function clearPlaceSearchMarker(mapId) {
          var mapObj = getMapFromId(mapId);
          var retVal = false;
          if (mapObj.placeMarkerPopup) {
            mapObj.map.removePopup(mapObj.placeMarkerPopup);
          }
          return retVal;
        };


        function dragStart(feature, stops, mapId) {
          var mapObj = getMapFromId(mapId);
          // var re = _.find(routeElements, { id: routeId });
          var x = feature.geometry.x;
          var y = feature.geometry.y;
          var stop = null;

          for (var index = 0; index < stops.length; index++) {
            var tempStop = stops[index].smLonLat;
            if ((tempStop.lat === y && tempStop.lon === x) ||
              (distanceTo(tempStop.lon, tempStop.lat, x, y) <= 0.25)) { // Todo: Report service does not return the same lat/lons as inputs. If a returned point is within 0.25 meter, we consider it match.
              stop = stops[index];
              break;
            }
          }


          if (stop != null) {
            if (feature.style != null && (feature.style.graphicTitle === "Origin" ||
                feature.style.graphicTitle === "Destination" || feature.style.graphicTitle === "Waypoint")) {

              clearSearchMarker(mapId);

              //if (feature.popup == null) {
              var address = stop.Address;

              var addressStr = stop.CityStateZip;
              if (address.StreetAddress !== "") {
                addressStr = `<b>${address.StreetAddress}</b><br>${addressStr}`;
              }
              var newTempStop = tempStop.lat+","+ tempStop.lon;
              // var disableSave = routeController.canSaveRoutePopupFavourite();
              
              mapObj.markerPopup = new ALKMaps.Popup.SimplePopup(
                "SelectedStopPopup",
                new ALKMaps.LonLat(feature.geometry.x, feature.geometry.y),
                null,
                `<div class="popup-text">${
                  addressStr
                }<div class="popup-actions">` +
                '    <button id="save-fav-btn" class="btn btn-default btn-xs" ng-style="routeVm.canSaveRoutePopupFavourite()" ng-click="routeVm.saveAndDeleteStopModal('+tempStop.lat+','+tempStop.lon+',false)" alk-analytics="[Map,Popup,AddFavorite]">' +
                '        <i class=\"ico ico-star\"></i> Save' +
                '    </button>' +
                '<button id="newTempStop" class="btn btn-default btn-xs" ng-click="routeVm.saveAndDeleteStopModal('+tempStop.lat+','+tempStop.lon+',true)" alk-analytics="[Map,Popup,DeleteStop]">'+
                '       <i class="ico ico-trash"></i> Delete Stop' +
                '   </button>' +
                "</div>" +
                "</div>",
                new ALKMaps.Pixel(0, 0), //offset
                true);
              // Don't pan the map, panning map will mess up dragging.
              mapObj.markerPopup.panMapIfOutOfView = false;
              mapObj.map.addPopup(mapObj.markerPopup);

              var e = angular.element("#SelectedStopPopup");
              $compile(e)(angular.element("#route-panel").scope());
            }
          }

          return stop;
        }

        function setDraggable(d) {
          isDraggable = d;
        }
        //#endregion

        //#region Traffic
        function showTrafficLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.trafficLayer.setVisibility(true);
          mapObj.savedInfo.showTraffic = true;
          // when user shows traffic layer, automatically hides road surface layer.
          hideRoadSurfaceLayer(mapId);
        }

        function hideTrafficLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.trafficLayer.setVisibility(false);
          mapObj.savedInfo.showTraffic = false;
        }

        function isTrafficVisible(mapId) {
          var mapObj = getMapFromId(mapId);
          var retVal = false;
          retVal = mapObj.trafficLayer.getVisibility();
          return retVal;
        }
        //#endregion

        //#region sites
        function showALKSitesLayer(mapId) {
          const mapObj = getMapFromId(mapId);
          ALKMaps.SSOToken = `token=${userProvider.getUser().authToken}`;
          mapObj.alkSitesLayer = new ALKMaps.Layer.Sites("ALK Sites", {
            minZoomLevel : 15,
            siteType : 1,
            includeSiteGates: true
          });
          mapObj.map.addLayer(mapObj.alkSitesLayer);
        }

        function showCustomSitesLayer(mapId) {
          const mapObj = getMapFromId(mapId);
          ALKMaps.SSOToken = `token=${userProvider.getUser().authToken}`;
          mapObj.customSitesLayer = new ALKMaps.Layer.Sites("Custom Sites", {
            minZoomLevel : 15,
            siteType : 2,
            includeSiteGates: true
          });
          mapObj.map.addLayer(mapObj.customSitesLayer);
        }

        function hideALKSitesLayer(mapId) {
          const mapObj = getMapFromId(mapId);
          const siteLayer = _.find(mapObj.map.layers, {
            name: "ALK Sites"
          });
          if (siteLayer) {
            siteLayer.destroy();
          }
        }

        function hideCustomSitesLayer(mapId) {
          const mapObj = getMapFromId(mapId);
          const siteLayer = _.find(mapObj.map.layers, {
            name: "Custom Sites"
          });
          if (siteLayer) {
            siteLayer.destroy();
          }
        }

        function isALKSitesVisible(mapId) {
          const mapObj = getMapFromId(mapId);
          return _.some(mapObj.map.layers, {
            name: "ALK Sites"
          });
        }

        function isCustomSitesVisible(mapId) {
          const mapObj = getMapFromId(mapId);
          return _.some(mapObj.map.layers, {
            name: "Custom Sites"
          });
        }

        function addFeatureEventControl(allLayers, mapId) {
          const mapObj = getMapFromId(mapId);
          const customPlaceSelectCtrl = new ALKMaps.Control.FeatureEvent(allLayers);
          mapObj.map.addControls([ customPlaceSelectCtrl ]);
          customPlaceSelectCtrl.activate();
        }

        function removeFeatureEventControl(mapId) {
          const mapObj = getMapFromId(mapId);
          const control = _.filter(mapObj.map.controls, (c) => {
            return c.displayClass === "olControlFeatureEvent"
          })
          mapObj.map.removeControl(control[0]);
        }
        //#region

        //#region Weather
        function showWeatherAlertsLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.weatherAlertsLayer.setVisibility(true);
          mapObj.savedInfo.showWeatherAlerts = true;
        }

        function hideWeatherAlertsLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.weatherAlertsLayer.setVisibility(false);
          mapObj.savedInfo.showWeatherAlerts = false;
        }

        function isWeatherAlertsVisible(mapId) {
          var mapObj = getMapFromId(mapId);
          var retVal = false;
          retVal = mapObj.weatherAlertsLayer.getVisibility();
          return retVal;
        }

        function showWeatherCloudLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.weatherCloudLayer.setVisibility(true);
          mapObj.savedInfo.showWeatherCloud = true;
        }

        function hideWeatherCloudLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.weatherCloudLayer.setVisibility(false);
          mapObj.savedInfo.showWeatherCloud = false;
        }

        function isWeatherCloudVisible(mapId) {
          var mapObj = getMapFromId(mapId);
          var retVal = false;
          retVal = mapObj.weatherCloudLayer.getVisibility();
          return retVal;
        }

        function showWeatherRadarLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.weatherRadarLayer.setVisibility(true);
          mapObj.savedInfo.showWeatherRadar = true;
        }

        function hideWeatherRadarLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.weatherRadarLayer.setVisibility(false);
          mapObj.savedInfo.showWeatherRadar = false;
        }

        function isWeatherRadarVisible(mapId) {
          var mapObj = getMapFromId(mapId);
          var retVal = false;
          retVal = mapObj.weatherRadarLayer.getVisibility();
          return retVal;
        }
        //#endregion

        //#region RoadSurface
        function showRoadSurfaceLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.roadSurfaceLayer.setVisibility(true);
          mapObj.savedInfo.showRoadSurface = true;
          // when user shows road surface layer, automatically hides traffic layer.
          hideTrafficLayer(mapId);
        }

        function hideRoadSurfaceLayer(mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.roadSurfaceLayer.setVisibility(false);
          mapObj.savedInfo.showRoadSurface = false;
        }

        function isRoadSurfaceVisible(mapId) {
          var mapObj = getMapFromId(mapId);
          var retVal = false;
          retVal = mapObj.roadSurfaceLayer.getVisibility();
          return retVal;
        }
        //#endregion

        //#region Map Styles
        function setStyle(style, mapId) {
          var mapObj = getMapFromId(mapId);

          if (mapObj.mapStyle !== style) {
            mapObj.mapStyle = style;
            if (style === "satellite_only") {
              mapObj.map.baseLayer.satelliteOnly = true;
              mapObj.map.baseLayer.changeStyle("satellite");
            } else {
              if (mapObj.map.baseLayer.satelliteOnly) {delete mapObj.map.baseLayer.satelliteOnly;}
              mapObj.map.baseLayer.changeStyle(style);
            }
          }
        }

        function setMapStyle(style, mapId) {
          var mapObj = getMapFromId(mapId);
          mapObj.map.baseLayer.changeStyle(style);
        }

        function getStyle(mapId) {
          var mapObj = getMapFromId(mapId);
          return mapObj.mapStyle;
        }
        //#endregion

        //#region Location Methods
        function getMapCenter(mapId) {
          var mapObj = getMapFromId(mapId);
          return transformFromSphericalMercator(mapObj.map.getCenter());
        }

        function panToLocation(resp, mapId) {
          var mapObj = getMapFromId(mapId);
          var tempStopListObj = {};

          tempStopListObj.lat = resp.Coords.Lat;
          tempStopListObj.lon = resp.Coords.Lon;

          var cleanLL = new ALKMaps.LonLat(resp.Coords.Lon, resp.Coords.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

          safePanTo(cleanLL, 16);
        }

        function safePanTo(lonlat, zoom, mapId) {
          var mapObj = getMapFromId(mapId);
          zoom = zoom || mapObj.map.getZoom();
          if (zoom > 7) {
            mapObj.map.zoomTo(4);
          }
          mapObj.map.panTo(lonlat);
          mapObj.map.zoomTo(zoom);
        }

        function getLocationString(mapId) {
          var mapObj = getMapFromId(mapId);
          if (!mapObj.map) {return $q.reject();}

          var deferred = $q.defer();

          var latLon = getMapCenter();

          alkGeocodeService.reverseGeocode(latLon, opt)
            .then((r) => {
              var retVal = "";
              var zoom = mapObj.map.getZoom();

              var resp = r[0];
              mapObj.currentLoc = resp;

              var strCity = `${resp.Address.City  } > `;
              var strCounty = (resp.Address.County != null && resp.Address.County !== "") ? `${resp.Address.County  } County > ` : "";
              var strState = resp.Address.State;
              var strCountry = "";
              var stObj = _.find(STATES, {
                abbreviation: resp.Address.State
              });

              if (stObj) {
                strState = `${stObj.name  } > `;
                strCountry = stObj.country;
              }
              switch (true) {
                case (zoom >= 13):
                  retVal = strCity + strCounty + strState + strCountry;
                  break;
                case (zoom >= 10):
                  retVal = strCounty + strState + strCountry;
                  break;
                case (zoom >= 7):
                  retVal = strState + strCountry;
                  break;
                case (zoom < 7):
                  retVal = strCountry;
              }

              deferred.resolve(retVal);
            })
            .catch((err) => {
              deferred.reject(err);
            });

          return deferred.promise;
        }

        function getCurrentLocation(mapId) {
          var mapObj = getMapFromId(mapId);
          return mapObj.currentLoc;
        }
        //#endregion

        //#region Helper Methods
        function transformFromSphericalMercator(lonLat, mapId) {
          var mapObj = getMapFromId(mapId);
          return lonLat.transform(mapObj.map.getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));
        }

        function transformToSphericalMercator(lonLat, mapId) {
          var mapObj = getMapFromId(mapId);
          return lonLat.transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());
        }

        function distanceTo(x, y, x1, y1) {
          return Math.sqrt(
            Math.pow(x - x1, 2) +
            Math.pow(y - y1, 2)
          );
        }

        function getLayersFromMap(filterArgs, mapId) {
          var mapObj = getMapFromId(mapId);
          return _.filter(mapObj.map.layers, filterArgs); //https://lodash.com/docs/4.17.10#filter
        }
        //#endregion

        //#region Internal Methods
        function plotCurrentPosition(position, mapId) {
          // if user is in NA and logs in to EU account. Use default EU center, not current location and vice versa.
          if ((position.coords.longitude > -20 && userProvider.getUser().region === "NA") || (position.coords.longitude < -20 && userProvider.getUser().region === "EU")) {
            return;
          }
          var mapObj = getMapFromId(mapId);

          if (mapObj.map !== null) {
            var myLonLat = new ALKMaps.LonLat(position.coords.longitude, position.coords.latitude).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());
            mapObj.map.setCenter(myLonLat, 12);
          }
        }

        function getMapFromId(mapId) {
          //if mapId is undefined, return first
          if (mapId === undefined) {
            return maps[0];
          }
          return _.find(maps, {
            id: mapId
          });
        }
        //#endregion

        // This methd implemented for event tracker, do not use this method to get userInfo
        function getUserCfg(storageKey, key) {
          var userCfg = $window.localStorage.getItem(storageKey);
          if (userCfg != null && userCfg != "undefined") {
            var obj = JSON.parse(userCfg);
            return key ? obj[key] : obj;
          }
        }
    
        function getLeastVersionIndex(version, version1) {
          const currentVersionNo = version.length > 5 ? angular.lowercase(version) : parseInt(version.substring(3,5));
          const previousVersionNo = version1.length > 5 ? angular.lowercase(version1) : parseInt(version1.substring(3,5));
            if((typeof (currentVersionNo) === "number") && (typeof (previousVersionNo) === "number")) {
              return currentVersionNo > previousVersionNo ? 1 : 0;
            } else {
              const versionArray =  [currentVersionNo, previousVersionNo];
              const index = versionArray.findIndex(val => typeof (val) === "number" );
              return index;
            }
        }

        function checkHistoricalVersion(version) {
          const versionNo = parseInt(version.substring(3, 5));
          var storageKey = "userCfg" + hashCode(userProvider.getUser().userId, userProvider.getUser().accountId);
          var userCfg = getUserCfg(storageKey, null);
          if(userCfg && userCfg.Minimum_Data_Version_Used && userCfg.Minimum_Data_Version_Used !== "") {
            const leastVersionIndex = getLeastVersionIndex(version, userCfg.Minimum_Data_Version_Used);
            if (leastVersionIndex === 0) {
              userCfg.Minimum_Data_Version_Used = version;
              var val =  JSON.stringify(userCfg);
              $window.localStorage.setItem(storageKey, val);
              window.sessionStorage.setItem("Minimum_Data_Version_Used", version);
              eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
                version
              });
            }            
          } else if(userCfg && !userCfg.hasOwnProperty('Minimum_Data_Version_Used')) {
            userCfg.Minimum_Data_Version_Used = version;
            var val =  JSON.stringify(userCfg);
            $window.localStorage.setItem(storageKey, val);
            window.sessionStorage.setItem("Minimum_Data_Version_Used", version);
            eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
              version
            });
          }
          
          return (typeof (versionNo) === "number" && versionNo >= 18 && versionNo <= 27);
        }

        
        function hashCode(a,b) {
          var num = 3 * a + 7 * b;
          var str = num.toString();
          var hash = 5381;
          for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i);
            hash = ((hash << 5) + hash) + char; /* hash * 33 + c */
          }
          return hash;
        }
        // function checkHistoricalVersion(version) {
        //   const versionNo = parseInt(version.substring(3, 5));
        //   return (typeof (versionNo) === "number" && versionNo >= 18 && versionNo <= 27);
        // Define the functions and properties to reveal.
        var service = {
          getCurrentLocation: getCurrentLocation,
          getMapCenter: getMapCenter,
          initializeMap: initializeMap,
          releaseMap: releaseMap,
          restoreCenterZoom: restoreCenterZoom,
          showPin: showPin,
          showPlacePin: showPlacePin,
          showPlaceHoverPopup: showPlaceHoverPopup,
          panToLocation: panToLocation,
          clearSearchMarker: clearSearchMarker,
          clearPlaceSearchMarker: clearPlaceSearchMarker,
          addRoute: addRoute,
          addRoutePromise: addRoutePromise,
          addReport: addReport,
          addReportPromise: addReportPromise,
          removeRoute: removeRoute,
          transformFromSphericalMercator: transformFromSphericalMercator,
          transformToSphericalMercator: transformToSphericalMercator,
          getLocationString: getLocationString,
          updateRouteMarkers: updateRouteMarkers,
          getStyle: getStyle,
          setStyle: setStyle,
          setMapStyle: setMapStyle,
          showRoute: showRoute,
          hideRoute: hideRoute,
          deleteRoute: deleteRoute,
          deleteAllRoutes: deleteAllRoutes,
          activateRoute: activateRoute,
          setRouteHandle: setRouteHandle,
          zoomIn: zoomIn,
          zoomOut: zoomOut,
          boxZoom: boxZoom,
          currentZoom: currentZoom,
          safePanTo: safePanTo,
          goBack: goBack,
          goForward: goForward,
          historyStack: historyStack,
          showTrafficLayer: showTrafficLayer,
          hideTrafficLayer: hideTrafficLayer,
          isTrafficVisible: isTrafficVisible,
          showALKSitesLayer: showALKSitesLayer,
          hideALKSitesLayer: hideALKSitesLayer,
          isALKSitesVisible: isALKSitesVisible,
          showCustomSitesLayer: showCustomSitesLayer,
          hideCustomSitesLayer: hideCustomSitesLayer,
          isCustomSitesVisible: isCustomSitesVisible,
          showWeatherAlertsLayer: showWeatherAlertsLayer,
          hideWeatherAlertsLayer: hideWeatherAlertsLayer,
          isWeatherAlertsVisible: isWeatherAlertsVisible,
          showWeatherCloudLayer: showWeatherCloudLayer,
          hideWeatherCloudLayer: hideWeatherCloudLayer,
          isWeatherCloudVisible: isWeatherCloudVisible,
          showWeatherRadarLayer: showWeatherRadarLayer,
          hideWeatherRadarLayer: hideWeatherRadarLayer,
          isWeatherRadarVisible: isWeatherRadarVisible,
          showRoadSurfaceLayer: showRoadSurfaceLayer,
          hideRoadSurfaceLayer: hideRoadSurfaceLayer,
          isRoadSurfaceVisible: isRoadSurfaceVisible,
          clearSavedCenterZoom: clearSavedCenterZoom,
          distanceTo: distanceTo,
          getMap: getMap,
          getLayer: getLayer,
          getMapFromId: getMapFromId,
          getRouteElements: getRouteElements,
          dragStart: dragStart,
          setDraggable: setDraggable,
          frameRoute: frameRoute,
          saveCenter: saveCenter,
          getSavedCenter: getSavedCenter,
          addFeatureEventControl: addFeatureEventControl,
          removeFeatureEventControl: removeFeatureEventControl,
          resetFeatureEventControl: resetFeatureEventControl,
          getLayersFromMap: getLayersFromMap,
          checkHistoricalVersion:checkHistoricalVersion
        };

        return service;
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/map/map.service.js